function saLoadScript(src) { 
    var js = window.document.createElement('script'); 
    js.src = src; 
    js.type = 'text/javascript'; 
    document.getElementsByTagName("head")[0].appendChild(js); 
}

setTimeout(function() {
    saLoadScript("https://www.shopperapproved.com/widgets/group2.0/31975.js");
}, 1000);